// extracted by css-extract-rspack-plugin
export default {"pageWrapper":"Iuel350H"};